/**
 * Created by lhzbxx on 2016/10/20.
 *
 * auth.js
 * 身份认证相关
 */

import * as types from '../mutation-types'
import http from '../../utils/fetch'
import cookie from 'vue-cookie'

const state = {
  isLogin: false,
  user: {
    phone: '',
    token: '',
    openId: '',
    isWxBound: false,
    nickname: '',
    userId: '',
    employeeNumber:''
  },
  companies: []
}

const mutations = {
  [types.RECEIVE_USER] (state, info) {
    state.user.nickname = info.nickname
    state.user.phone = info.phone
    state.user.isWxBound = info.isWxBound
    state.user.userId = info.id
    state.user.employeeNumber = info.employeeNumber
    window.localStorage.setItem('user', JSON.stringify(info))
    // 登录成功后清除上次选中的customer
    window.localStorage.removeItem('customer')
  },
  [types.USER_LOGIN_SUCCESS] (state, {phone, token}) {
    state.isLogin = true
    state.user.phone = phone
    state.user.token = token
    window.localStorage.createAt = new Date().valueOf()
    window.localStorage.setItem('user', JSON.stringify(state.user))
    window.localStorage.setItem('token', token)
    http.setToken(token)
  },
  [types.USER_LOGOUT] (state) {
    state.isLogin = false
    state.user = {}
    window.localStorage.removeItem('createAt')
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('token')
    window.delCookie('token')
    window.delCookie('userId')
    window.delCookie('shareId')
    window.delCookie('sharePhone')
    http.clearToken()
  },
  [types.GET_DATA_FROM_STORAGE] (state) {
    console.log('auth:GET_DATA_FROM_STORAGE')
    state.isLogin = true
    state.user = JSON.parse(window.localStorage.getItem('user'))
  },
  [types.ADD_COMPANY] (state, company) {
    state.companies.push(company)
    window.localStorage.setItem('companies', JSON.stringify(state.companies))
  },
  [types.UPDATE_COMPANY] (state, company) {
    for (let i = 0; i < state.companies.length; i++) {
      if (company.id === state.companies[i].id) {
        state.companies[i] = company
      }
    }
  },
  [types.INIT_COMPANIES] (state, companies) {
    state.companies = companies
    window.localStorage.setItem('companies', JSON.stringify(companies))
  },
  [types.RECEIVE_OPEN_ID] (state, openId) {
    state.user.openId = openId
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/auth.js